import React, { useEffect } from 'react';
import WithPosition from '../../components/common/hoc/resetPagePosition';
import { Outlet } from 'react-router-dom';
import DocMenus from './docMenu';
import { Topics } from './docLinks';

const Documentation = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{display: 'flex', width: '80%', margin: 'auto'}}>
      <div style={{width: '220px', height: 'auto', minHeight: '800px', borderRight: '1px solid lightgray'}}>
        {Topics.map((item, index) => {
          return (
            <DocMenus key={index} menus={item} />
          )
        })}
      </div>
      <div style={{flex: '1 1', height: 'auto', minHeight: '800px', backgroundColor: 'white', padding: '0px 30px 20px 30px'}}>
        <Outlet />
      </div>
    </div>
  )
}

export default WithPosition(Documentation);